import { LoginTimeout, Unauthenticated } from "../types/login";

const UNAUTHENTICATED_STATUSES: ReadonlyArray<Unauthenticated["status"]> = [
    "pinRequired",
    "setupRequired",
    "notAuthenticated",
    "phoneNotVerified",
];

/**
 * Narrows the body of a 401 response from a login-flow endpoint.
 * Other 401 responses carry a plain text body.
 */
function isUnauthenticated(data: unknown): data is Unauthenticated {
    return (
        typeof data === "object" &&
        data !== null &&
        "status" in data &&
        UNAUTHENTICATED_STATUSES.some((status) => status === data.status)
    );
}

/** Narrows the body of a 408 response from a login-flow endpoint. */
function isLoginTimeout(data: unknown): data is LoginTimeout {
    return (
        typeof data === "object" &&
        data !== null &&
        "cause" in data &&
        (data.cause === "pinCode" || data.cause === "credentials")
    );
}

export { isUnauthenticated, isLoginTimeout };
